import React, { useState } from 'react';
import useDevice from '../../../hooks/useDevice.mjs';
import VerticalList from '../../Basic/Lists/VerticalList/VerticalList.mjs';
import VerticalAccordion from '../VerticalAccordion/VerticalAccordion.mjs';
import { Container, SectionWrapper } from './MenuContent.styles.mjs';

const MenuContent = ({ sections = [] }) => {
    const { isMobile } = useDevice();
    const firstSection = sections[0];
    const openByDefault = [firstSection === null || firstSection === void 0 ? void 0 : firstSection.id];
    const [openAccordions, setOpenAccordions] = useState(new Set(openByDefault));
    const handleAccordionClick = (id) => {
        setOpenAccordions(previousOpenAccordions => {
            const nextOpenAccordions = new Set(previousOpenAccordions);
            nextOpenAccordions.has(id) ? nextOpenAccordions.delete(id) : nextOpenAccordions.add(id);
            return nextOpenAccordions;
        });
    };
    return (React.createElement(Container, null, sections.map(({ id, heading, options, onClick }) => (React.createElement(SectionWrapper, { key: id, isOpen: openAccordions.has(id) }, isMobile ? (React.createElement(VerticalAccordion, { heading: heading, options: options, isOpen: openAccordions.has(id), onClick: () => handleAccordionClick(id), onOptionClick: onClick })) : (React.createElement(VerticalList, { heading: heading, options: options, onClick: onClick })))))));
};

export { MenuContent as default };
//# sourceMappingURL=MenuContent.mjs.map
